import { TextField, TextFieldProps } from '@mui/material'
import './styles.scss'

type TFormTextInputProps = Omit<TextFieldProps, 'variant'> & {
  className?: string
  variant?: 'standard' | 'filled' | 'outlined'
}

const FormTextInput = ({
  className,
  variant = 'standard',
  ...props
}: TFormTextInputProps) => {
  return (
    <TextField
      {...props}
      variant={variant}
      className={`form-text-input ${props.error ? 'error' : ''}${variant} ${className ?? ''}`}
      fullWidth
    />
  )
}

export default FormTextInput
